<template>
  <div>
    <!-- <van-nav-bar title="学生考勤" /> -->
    <van-tabs
      color="#1989fa"
      background="none"
      @change="handleChangeTab"
      :ellipsis="false"
      :swipeable="true"
    >
      <van-tab
        v-for="item in childList"
        :title="item.name + '(' + item.className + ')'"
        :name="item.id"
        :key="item.id"
      ></van-tab>
    </van-tabs>

    <div class="wrap">
      <div class="today">
        <div class="today-title">
          <span style="margin-right: 1rem">今天</span>
          <span>{{ curD }}</span>
        </div>
        <div class="timeline-box">
          <div class="timeline">
            <div class="timeline-item" :class="todayData.amstartState">
              <div class="circle" :class="todayData.amstartStateIcon">
                <div class="late-cir"></div>
              </div>
              <div class="time">{{ todayData.amstart }}</div>
            </div>
            <div class="timeline-item" :class="todayData.amendState">
              <div class="circle" :class="todayData.amendStateIcon">
                <div class="late-cir"></div>
              </div>
              <div class="time">{{ todayData.amend }}</div>
            </div>
            <div class="timeline-item" :class="todayData.pmstartState">
              <div class="circle" :class="todayData.pmstartStateIcon">
                <div class="late-cir"></div>
              </div>
              <div class="time">{{ todayData.pmstart }}</div>
            </div>
            <div class="timeline-item" :class="todayData.pmendState">
              <div class="circle" :class="todayData.pmendStateIcon">
                <div class="late-cir"></div>
              </div>
              <div class="time">{{ todayData.pmend }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="screen">
        <div class="screen-wrap" @click="$refs.starttime.showTimePopup = true">
          <div>选择时间{{ date }}</div>
          <span class="iconfont">&#xe607;</span>
        </div>
      </div> -->

      <!-- <van-dropdown-menu
        :close-on-click-outside="false"
        style="border-radius: 0.85rem;overflow: hidden;"
      >
        <van-dropdown-item :title="dropdownTitle" ref="dropmenu">
          <div class="screen-wrap-popup">
            <van-row class="screenwrap">
              <van-col :span="6"><div class="left">开始时间</div></van-col>
              <van-col :span="18"
                ><div class="input-content" @click="clickTime('starttime')">
                  {{ starttime }}
                </div></van-col
              >
            </van-row>
            
            <van-row class="screenwrap">
              <van-col :span="6"><div class="left">结束时间</div></van-col>
              <van-col :span="18"
                ><div class="input-content" @click="clickTime('endtime')">
                  {{ endtime }}
                </div></van-col
              >
            </van-row>

            <van-row :gutter="20" style="margin-top: 10px;">
              <van-col :span="12"
                ><van-button block @click="$refs.dropmenu.toggle()"
                  >取消</van-button
                ></van-col
              >
              <van-col :span="12"
                ><van-button type="info" block @click="handleShowData"
                  >确定</van-button
                ></van-col
              >
            </van-row>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
      -->

      <div
        style="
          border-top-left-radius: 1rem;
          border-top-right-radius: 1rem;
          background: white;
          margin-top: 1rem;
          padding-bottom: 0.5rem;
        "
      >
        <div class="class-date flex flex-center">
          <van-icon name="arrow-left" @click="prevArrow" />
          <span @click="selectDate">{{ date }}</span>
          <van-icon name="arrow" @click="nextArrow" />
        </div>
        <SelectTime
          ref="startmonth"
          :typeTime="'选择月份'"
          @time="handleTimeConfirms"
          :minDate="minDates"
          :maxDate="new Date()"
          type="year-month"
          :currentDate="startMinTimes"
        />
      </div>

      <div class="info">
        <div class="info-item">
          <div class="info-count">
            <span>{{ data.absenceDay || 0 }}</span>
            <span class="unit">天</span>
          </div>
          <div class="info-name">应到</div>
        </div>
        <div class="info-item">
          <div class="info-count">
            <span>{{ data.normalDay || 0 }}</span>
            <span class="unit">天</span>
          </div>
          <div class="info-name">实到</div>
        </div>
        <div class="info-item">
          <div class="info-count">
            <span class="redinfo">{{ data.attendanceDay || 0 }}</span>
            <span class="unit">天</span>
          </div>
          <div class="info-name">缺勤</div>
        </div>
        <div class="info-item">
          <div class="info-count">
            <span>{{ data.leaveTimes || 0 }}</span>
            <span class="unit">次</span>
          </div>
          <div class="info-name">请假</div>
        </div>
      </div>

      <!-- 日历 -->
      <div
        style="
          border-radius: 1rem;
          background: white;
          overflow: hidden;
          margin-top: 1rem;
        "
      >
        <el-calendar ref="calendar" v-model="calendarDate">
          <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
          <template slot="dateCell" slot-scope="{ date, data }">
            <div class="cells">
              <!-- 非本月显示天数 -->
              <div class="lowerTop">{{ Number(data.day.split("-")[2]) }}</div>
              <!-- 循环对比数据 -->
              <div v-for="item in calendarList" class="For">
                <div
                  v-if="
                    item.day == data.day &&
                    Number(item.day.slice(5, 7)) ==
                      new Date(calendarDate).getMonth() + 1
                  "
                  class="content"
                >
                  <span
                    :class="
                      item.holidayState ? 'state' + item.holidayState : ''
                    "
                    >{{
                      item.holidayState == 1
                        ? "休"
                        : item.holidayState == 2
                        ? "班"
                        : ""
                    }}</span
                  >
                  <!-- 单击某项日历弹出框内容 -->
                  <el-popover
                    placement="bottom"
                    width="200"
                    trigger="click"
                    :disabled="
                      item.amFirstClockTime ||
                      item.amLastClockTime ||
                      item.pmFirstClockTime ||
                      item.pmLastClockTime ||
                      item.leave ||
                      item.day == todayTime
                        ? false
                        : true
                    "
                  >
                    <div class="today">
                      <div
                        v-if="item.leave"
                        style="
                          font-size: 0.8rem;
                          color: rgb(241, 203, 42);
                          text-align: center;
                        "
                      >
                        当天有请假
                      </div>
                      <div class="timeline-box">
                        <div class="timeline">
                          <div
                            class="timeline-item"
                            :class="item.todayData.amstartState"
                          >
                            <div
                              class="circle"
                              :class="item.todayData.amstartStateIcon"
                            >
                              <div class="late-cir"></div>
                            </div>
                            <div class="time">{{ item.todayData.amstart }}</div>
                          </div>
                          <div
                            class="timeline-item"
                            :class="item.todayData.amendState"
                          >
                            <div
                              class="circle"
                              :class="item.todayData.amendStateIcon"
                            >
                              <div class="late-cir"></div>
                            </div>
                            <div class="time">{{ item.todayData.amend }}</div>
                          </div>
                          <div
                            class="timeline-item"
                            :class="item.todayData.pmstartState"
                          >
                            <div
                              class="circle"
                              :class="item.todayData.pmstartStateIcon"
                            >
                              <div class="late-cir"></div>
                            </div>
                            <div class="time">{{ item.todayData.pmstart }}</div>
                          </div>
                          <div
                            class="timeline-item"
                            :class="item.todayData.pmendState"
                          >
                            <div
                              class="circle"
                              :class="item.todayData.pmendStateIcon"
                            >
                              <div class="late-cir"></div>
                            </div>
                            <div class="time">{{ item.todayData.pmend }}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div slot="reference">
                      <div
                        :class="item.ToSchoolState ? item.ToSchoolState : ''"
                      >
                        <!-- 显示本月天数 显示假期情况 -->
                        <div
                          :class="data.day == todayTime ? 'todayShow' : 'show'"
                        >
                          {{ Number(item.day.split("-")[2]) }}
                        </div>
                        <!-- <span
                          :class="
                            item.holidayState ? 'state' + item.holidayState : ''
                          "
                          >{{
                            item.holidayState == 1
                              ? "休"
                              : item.holidayState == 2
                              ? "班"
                              : ""
                          }}</span> -->
                      </div>
                      <div class="InOutTime">
                        <!-- 请假或缺勤 -->
                        <div v-if="item.ToSchoolState == 'red'" class="timeRed">
                          缺
                        </div>
                        <div
                          v-else-if="item.ToSchoolState == 'yellow'"
                          class="timeYellow"
                        >
                          假
                        </div>
                        <!-- 显示打卡时间 -->
                        <div v-else class="timeNone">
                          <p :class="setClassName(item, 'top')">
                            {{ setContent(item, "top") }}
                          </p>
                          <p :class="setClassName(item, 'bottom')">
                            {{ setContent(item, "bottom") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </div>
              </div>
            </div>
          </template>
        </el-calendar>
      </div>

      <!-- <div class="list">
        <van-collapse v-model="activeNames">
          <van-collapse-item
            v-for="(item, index) in listStatus.filter((item) => item.num > 0)"
            :key="index"
            :title="item.title"
            :name="item.name"
            :disabled="item.listContent.length <= 0"
            size="large"
          >
            <div
              class="collapse-cell"
              v-for="v in item.listContent"
              :key="v.value"
            >
              {{ v.value }}
            </div>
          </van-collapse-item>
        </van-collapse>
      </div> -->
    </div>
    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :minDate="minDate"
      :maxDate="new Date()"
      type="date"
      :currentDate="startMinTime"
    />
    <SelectTime
      ref="endtime"
      :typeTime="'选择结束时间'"
      @time="handleTimeEndConfirm"
      :minDate="minDate"
      type="date"
      :currentDate="endCurTime"
      :maxDate="new Date()"
    />
  </div>
</template>

<script>
import moment from "moment";
import { compare, getDateYMD, timeFormart } from "@/utils";
import SelectTime from "@/components/subScribePopup/selectTime";
import axios from "axios";
export default {
  data() {
    return {
      activeNames: [0, 1, 3, 4, 5, 6],
      columns: [],
      curD: moment().format("YYYY年MM月DD日"),

      dropdownTitle: "",
      starttime: moment().startOf("month").format("YYYY-MM-DD"),
      endtime: moment().format("YYYY-MM-DD"),
      todayData: {},
      minDate: new Date(2020, 1, 1),
      endCurTime: new Date(moment().format("YYYY-MM-DD")),
      listStatus: [],
      data: {},
      childList: [],
      childId: "",

      todayTime: moment(new Date()).format("YYYY-MM-DD"),
      date: moment().format("YYYY-MM"), //当前时间选择器选择的时间
      startMinTimes: new Date(moment().format("YYYY-MM")), //时间选择器默认时间
      minDates: new Date(2020, 0), //时间选择器最小时间

      calendarList: [], //日历遍历数据
      calendarDate: new Date(), //日历绑定日期
      holiday: [], //节假日列表
    };
  },
  mounted() {
    this.getHolidayState(); //获取节假日
    this.getAllChild();
    this.changeCalendarCss(); //更改日历样式
    this.getMonthCalendarData(); //获取本月打卡汇总
    this.getCalendarList(); //获取日历数据
    this.dropdownTitle = `${this.starttime}至${this.endtime}`;
  },
  watch: {
    date() {
      this.calendarDate = new Date(this.date);
      let date = this.date.split("-");
      let today = this.todayTime.split("-");
      if (date[0] == today[0]) {
        if (date[1] <= today[1]) {
          this.getCalendarList();
          this.getMonthCalendarData();
        } else {
          this.data = {};
        }
      } else {
        this.getCalendarList();
        this.getMonthCalendarData();
      }
    },
    calendarDate() {
      this.date = moment(this.calendarDate).format("YYYY-MM");
    },
    childId() {
      this.getCalendarList();
      this.getMonthCalendarData();
    },
  },
  computed: {
    startMinTime() {
      return new Date(moment().year(), moment().month(), 1); // 数字
    },
    personType() {
      return JSON.parse(localStorage.getItem("userInfo")).personType;
    },
  },
  methods: {
    handleTimeStartConfirm(value) {
      this.starttime = value;
    },
    handleTimeEndConfirm(value) {
      this.endtime = value;
    },
    clickTime(type) {
      this.$refs[type].showTimePopup = true;
    },
    handleChangeTab(id) {
      this.childId = id;
      // this.getStatistics();
      this.getCalendar();
    },
    async getAllChild() {
      const { code, data } = await this.$https.getAllChild({
        userId: this.$store.state.puserId,
        schoolId: this.$store.state.pschoolId,
      });

      if (code !== 200) {
        return;
      }
      this.childList = data;
      // this.getCalendar()
      // this.radio = data[0]
      this.childId = data[0].id;
      // if (this.radio.id) {
      // this.getStatistics();
      this.getCalendar();
      // }
      // this.$set(this.form, 'radio', data[0])
    },
    handleShowData() {
      const start = moment(this.starttime, "YYYY-MM-DD");
      const end = moment(this.endtime, "YYYY-MM-DD");
      if (end.diff(start, "day") > 31) {
        this.$toast("最大时间为31天");
        return false;
      }
      this.dropdownTitle = `${this.starttime}至${this.endtime}`;
      // this.$refs.dropmenu.toggle();

      // this.getStatistics();
    },

    // async getStatistics() {
    //   const { code, data, msg } = await this.$https.statistics({
    //     userId: this.childId,
    //     startTime: this.starttime,
    //     endTime: this.endtime,
    //   });
    //   if (code !== 200) {
    //     this.$toast(msg);
    //     this.listStatus = [];
    //     this.data = {};
    //     return;
    //   }
    //   this.data = data;

    //   // this.$toast().clear()
    //   const transformTime = (min) => {
    //     if (min < 60) {
    //       return min + "分钟";
    //     }
    //     let h = Math.floor(min / 60);
    //     let m = Math.floor(min % 60);
    //     if (m > 0) {
    //       return `${h}小时${m}分钟`;
    //     }
    //     return `${h}小时`;
    //   };
    //   this.listStatus = [
    //     {
    //       title: `迟到${data.lateNumber}次`,
    //       listContent: data.listLate.map((item) => {
    //         item.value = `${getDateYMD(item.signinTime)}迟到${transformTime(
    //           item.lateTime
    //         )}`;
    //         return item;
    //       }),
    //       num: data.lateNumber,
    //       name: 1,
    //     },

    //     // {
    //     //   title: `加班${data.workNumber}次`,
    //     //   listContent: data.listOverTimeHistory.map((item) => {
    //     //     item.value = `${getDateYMD(item.lastClockTime)}加班${
    //     //       item.overTime
    //     //     }小时`
    //     //     return item
    //     //   }),
    //     //   num: data.workNumber,
    //     //   name: 3,
    //     // },
    //     {
    //       title: `早退${data.leaveEarly}次`,
    //       listContent: data.listEarlyHistory.map((item) => {
    //         item.value = `${getDateYMD(item.earlyTime)}早退${transformTime(
    //           item.duration
    //         )}`;
    //         return item;
    //       }),
    //       num: data.leaveEarly,
    //       name: 4,
    //     },
    //     // {
    //     //   title: `缺勤${data.absence}次`,
    //     //   listContent: data.listAbsenceHistory.map((item) => {
    //     //     item.value = `${getDateYMD(item.absenceDate)}缺勤`
    //     //     return item
    //     //   }),
    //     //   num: data.absence,
    //     //   name: 5,
    //     // },
    //     {
    //       title: `请假${data.leaveNumber}次`,
    //       listContent: data.listLeave
    //         ? data.listLeave.map((item) => {
    //             item.value = `${getDateYMD(item.startTime)}至${getDateYMD(
    //               item.endTime
    //             )}请假`;
    //             return item;
    //           })
    //         : [],
    //       num: data.leaveNumber,
    //       name: 6,
    //     },
    //     {
    //       title: `未打卡${data.frequency}次`,
    //       listContent: data.listMissed.map((item) => {
    //         item.value = `${item.punchTime}${item.punchType}`;
    //         return item;
    //       }),
    //       num: data.frequency,
    //       name: 2,
    //     },
    //     // {
    //     //   title: `外勤${data.absence}次`,
    //     //   num: data.absence,
    //     //   listContent: [],
    //     //   name: 7,
    //     // },
    //   ];
    //   if (data.frequency < 10) {
    //     this.activeNames.push(2);
    //   }
    // },

    async getCalendar() {
      //获取头部今日打卡信息
      const { data, code } = await this.$https.getCalendar({
        userId: this.childId,
        date: moment(new Date()).format("YYYY-MM-DD"),
      });
      if (code !== 200) {
        return false;
      }
      const item = data[0];

      const hm = (value) => {
        return moment(value).format("HH:mm");
      };
      const map = {
        "-1": ["orange", "late"],
        0: ["grey", "success"],
        1: ["blue", "success"],
        "-2": ["orange", "late"],
      };

      this.todayData = {
        amstartState: item.amFirstClockState
          ? map[item.amFirstClockState][0]
          : "grey",
        amendState: item.amLastClockState
          ? map[item.amLastClockState][0]
          : "grey",
        pmstartState: item.pmFirstClockState
          ? map[item.pmFirstClockState][0]
          : "grey",
        pmendState: item.pmLastClockState
          ? map[item.pmLastClockState][0]
          : "grey",

        amstartStateIcon: item.amLastClockState
          ? map[item.amFirstClockState][1]
          : "success",
        amendStateIcon: item.amLastClockState
          ? map[item.amLastClockState][1]
          : "success",
        pmstartStateIcon: item.pmFirstClockState
          ? map[item.pmFirstClockState][1]
          : "success",
        pmendStateIcon: item.pmLastClockState
          ? map[item.pmLastClockState][1]
          : "success",

        amstart: item.amFirstClockTime ? hm(item.amFirstClockTime) : "",
        amend: item.amLastClockTime ? hm(item.amLastClockTime) : "",
        pmstart: item.pmFirstClockTime ? hm(item.pmFirstClockTime) : "",
        pmend: item.pmLastClockTime ? hm(item.pmLastClockTime) : "",
      };
    },

    changeCalendarCss() {
      //更改日历样式
      this.$refs.calendar.$el.firstElementChild.style.display = "none";
      let th =
        this.$refs.calendar.$el.children[1].children[0].childNodes[0]
          .childNodes;
      th.forEach((item) => {
        item.style.textAlign = "center";
        item.style.fontSize = "0.9rem";
        item.style.fontFamily = "黑体";
        // item.style.fontWeight = "600";
        item.childNodes[0].nodeValue = "周" + item.childNodes[0].nodeValue;
      });
      this.$refs.calendar.$el.childNodes[1].childNodes[0].childNodes[1].childNodes.forEach(
        (tr) => {
          tr.childNodes.forEach((td) => {
            td.style.border = "none";
            td.childNodes[0].style.height = "3rem";
          });
        }
      );
    },
    setReqTime(time) {
      //获取每月天数
      let newTime = moment(new Date()).format("YYYY-MM").split("-");
      time = time.split("-");
      function getEndTime(arr) {
        if (["01", "03", "05", "07", "08", "10", "12"].indexOf(arr[1]) !== -1) {
          arr[2] = "31";
        } else if (["04", "06", "09", "11"].indexOf(arr[1]) !== -1) {
          arr[2] = "30";
        } else if (arr[1] === "02") {
          if (arr[0] % 4 == 0) {
            arr[2] = "29";
          } else {
            arr[2] = "28";
          }
        }
        return arr.join("-");
      }
      this.starttime = time.join("-");
      this.starttime += "-01";
      if (newTime[0] === time[0] && newTime[1] === time[1]) {
        this.endtime = moment(new Date()).format("YYYY-MM-DD");
      } else {
        this.endtime = getEndTime(time);
      }
    },
    selectDate() {
      this.$refs.startmonth.showTimePopup = true;
    },
    prevArrow() {
      //当前月份减
      function reduceTime(item) {
        item.date = moment(item.date).subtract(1, "months").format("YYYY-MM");
        item.startMinTimes = new Date(item.date);
      }
      new Date(this.date).getFullYear() == this.minDate.getFullYear()
        ? new Date(this.date).getMonth() > this.minDate.getMonth()
          ? reduceTime(this)
          : ""
        : reduceTime(this);
      this.setReqTime(this.date);
      this.handleShowData();
    },
    nextArrow() {
      //当前月份加
      function addTime(item) {
        item.date = moment(item.date).add(1, "months").format("YYYY-MM");
        item.startMinTimes = new Date(item.date);
      }
      // new Date(this.date).getFullYear() == new Date().getFullYear()
      //   ? new Date(this.date).getMonth() < new Date().getMonth()
      //     ? addTime(this)
      //     : ""
      //   : addTime(this);
      addTime(this);
      this.setReqTime(this.date);
      this.handleShowData();
    },
    //判断是否是ios系统
    appSource() {
      const u = navigator.userAgent, app = navigator.appVersion;
      //const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      return isiOS
    },
    handleTimeConfirms(time) {
      var timeDate=time
      var ios=this.appSource()
      if(ios){
        timeDate= time.replace(/-/g,'/')
      }
      //时间选择器变化回调
      this.date = moment(new Date(timeDate)).format("YYYY-MM");
      this.setReqTime(this.date);
      this.handleShowData();
    },
    async getCalendarList() {
      //获取日历
      const { data, code } = await this.$https.getStudentMonthCalendar({
        //发送请求
        userId: this.childId,
        date: moment(this.date).format("YYYY-MM"),
      });
      if (code !== 200) {
        return;
      }
      this.calendarList = [];
      data.forEach((item) => {
        let Template = {
          day: item.day, //当天日期
          leave: item.leaveState ? item.leaveState : 0, //当天是否请假  请假为1  未请假为0
          absence: item.absenceState ? item.absenceState : 0, //当天是否缺勤  缺勤为1  未缺勤为0

          amFirstClockTime: item.amFirstClockTime
            ? moment(item.amFirstClockTime).format("HH:mm")
            : "", //早上第一次打卡时间
          amFirstClockState: item.amFirstClockState
            ? item.amFirstClockState
            : 0, //早上第一次打卡状态     迟到为-1 正常为1 未打卡为0

          amLastClockTime: item.amLastClockTime
            ? moment(item.amLastClockTime).format("HH:mm")
            : "", //早上最后一次打卡时间
          amLastClockState: item.amLastClockState ? item.amLastClockState : 0, //早上第二次打卡状态     早退为-2 正常 未打卡为0

          pmFirstClockTime: item.pmFirstClockTime
            ? moment(item.pmFirstClockTime).format("HH:mm")
            : "", //下午第一次打卡时间
          pmFirstClockState: item.pmFirstClockState
            ? item.pmFirstClockState
            : 0, //下午第一次打卡状态     迟到为-2 正常为1 未打卡为0

          pmLastClockTime: item.pmLastClockTime
            ? moment(item.pmLastClockTime).format("HH:mm")
            : "", //下午最后一次打卡时间
          pmLastClockState: item.pmLastClockState ? item.pmLastClockState : 0, //下午最后一次打卡状态     早退为-2 正常 未打卡为0

          holidayState: 0, //当日是否为节假日   不是为0  是节假日为1  节假日且要加班为2
          ToSchoolState: "none", //数字颜色  请假yellow  缺勤red  无状态none
        };
        if (
          Template.leave &&
          !Template.amFirstClockTime &&
          !Template.pmLastClockState
        ) {
          Template.ToSchoolState = "red";
        } else if (Template.absence) {
          Template.ToSchoolState = "red";
        } else {
          Template.ToSchoolState = "none";
        }
        Template.todayData = this.getTodayData(Template);
        Template.holidayState = this.setHolidayState(Template.day);
        this.calendarList.push(Template);
      });
    },
    async getHolidayState() {
      //获取节假日
      let startYear = this.minDate.getFullYear();
      let endYear = new Date().getFullYear();
      let holiday = [];
      let promise = [];
      // let arr = [];
      for (let i = startYear; i <= endYear; i++) {
        holiday.push({ year: i });
        promise.push(
          await this.$https.getHolidaysDay({
            date: i,
          })
        );
      }
      Promise.all(promise).then((data) => {
        data.forEach((item, index) => {
          holiday[index].holiday = item.data.holiday;
        });
        this.holiday = holiday;
      });

      Promise.all(promise).then((data) => {
        data.forEach((item, index) => {
          for (let i = item.data.length - 1; i--; i >= 1) {
            if (
              item.data[i].name == "周六" ||
              item.data[i].name == "周日" ||
              item.data[i].name == "休息日"
            ) {
              item.data.splice(i, 1);
            }
          }
          holiday[index].holiday = item.data;
        });
        console.log('获取到hoilday',holiday)
        this.holiday = holiday;
      });
    },

    setHolidayState(day) {
      //设置单项日历内节假日状态
      day = day.split("-");
      let state = 0;

      console.log('获取到年份',this.holiday)

      this.holiday.forEach((Year) => {
        if (Year.year == day[0]) {
          Year.holiday && Year.holiday.forEach((item) => {
            if (day.join("-") == item.date) {
              if (item.type == 2) {
                state = 1;
              } else if (item.type == 3) {
                state = 2;
              }
            }
          });
        }
      });
      return state;
    },
    getTodayData(item) {
      //获取日历气泡显示图标
      const map = {
        "-1": ["orange", "late"],
        0: ["grey", "success"],
        1: ["blue", "success"],
        "-2": ["orange", "late"],
      };
      let todayData = {
        amstartState: item.amFirstClockState
          ? map[item.amFirstClockState][0]
          : "grey",
        amendState: item.amLastClockState
          ? map[item.amLastClockState][0]
          : "grey",
        pmstartState: item.pmFirstClockState
          ? map[item.pmFirstClockState][0]
          : "grey",
        pmendState: item.pmLastClockState
          ? map[item.pmLastClockState][0]
          : "grey",

        amstartStateIcon: item.amLastClockState
          ? map[item.amFirstClockState][1]
          : "success",
        amendStateIcon: item.amLastClockState
          ? map[item.amLastClockState][1]
          : "success",
        pmstartStateIcon: item.pmFirstClockState
          ? map[item.pmFirstClockState][1]
          : "success",
        pmendStateIcon: item.pmLastClockState
          ? map[item.pmLastClockState][1]
          : "success",

        amstart: item.amFirstClockTime ? item.amFirstClockTime : "",
        amend: item.amLastClockTime ? item.amLastClockTime : "",
        pmstart: item.pmFirstClockTime ? item.pmFirstClockTime : "",
        pmend: item.pmLastClockTime ? item.pmLastClockTime : "",
      };
      return todayData;
    },
    async getMonthCalendarData() {
      //获取统计数据
      const { data, code } = await this.$https.getStudentMonthCalendarData({
        //获取统计数据
        userId: this.childId,
        date: moment(this.date).format("YYYY-MM"),
      });
      if (code !== 200) {
        return;
      }
      this.data = data;
    },

    setClassName(item, type) {
      let arr = [
        item.amFirstClockState,
        item.amLastClockState,
        item.pmFirstClockState,
        item.pmLastClockState,
      ];
      let showItem = "";
      switch (type) {
        case "top":
          if (arr.filter((item) => item).length < 2) {
            arr[0]
              ? (showItem = "amFirstClockState")
              : arr[2]
              ? (showItem = "pmFirstClockState")
              : "";
          } else {
            arr[0]
              ? (showItem = "amFirstClockState")
              : arr[1]
              ? (showItem = "amLastClockState")
              : arr[2]
              ? (showItem = "pmFirstClockState")
              : "";
          }
          break;
        case "bottom":
          if (arr.filter((item) => item).length < 2) {
            arr[3]
              ? (showItem = "pmLastClockState")
              : arr[1]
              ? (showItem = "amLastClockState")
              : "";
          } else {
            arr[3]
              ? (showItem = "pmLastClockState")
              : arr[2]
              ? (showItem = "pmFirstClockState")
              : arr[1]
              ? (showItem = "amLastClockState")
              : "";
          }
          break;
        default:
      }
      return !item[showItem]
        ? "show"
        : item[showItem] == -1 || item[showItem] == -2
        ? "late"
        : "";
    },
    setContent(item, type) {
      let arr = [
        item.amFirstClockTime,
        item.amLastClockTime,
        item.pmFirstClockTime,
        item.pmLastClockTime,
      ];
      let showItem = "";
      switch (type) {
        case "top":
          if (arr.filter((item) => item).length < 2) {
            arr[0] ? (showItem = arr[0]) : arr[2] ? (showItem = arr[2]) : "";
          } else {
            arr[0]
              ? (showItem = arr[0])
              : arr[1]
              ? (showItem = arr[1])
              : arr[2]
              ? (showItem = arr[2])
              : "";
          }
          break;
        case "bottom":
          if (arr.filter((item) => item).length < 2) {
            arr[3] ? (showItem = arr[3]) : arr[1] ? (showItem = arr[1]) : "";
          } else {
            arr[3]
              ? (showItem = arr[3])
              : arr[2]
              ? (showItem = arr[2])
              : arr[1]
              ? (showItem = arr[1])
              : "";
          }
          break;
        default:
      }
      return showItem;
    },
  },
  components: {
    SelectTime,
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 0 0.5rem 1rem 0.5rem;
}
.today {
  background: #fff;
  border-radius: 0.85rem;
  margin-top: 0.8rem;
  .today-title {
    color: #78849e;
    padding: 0.8rem 1rem;
    font-size: 0.75rem;
  }
  .timeline-box {
    padding: 0.5rem 1rem 0.5rem 1rem;
    .timeline {
      width: 100%;
      display: flex;

      justify-content: space-between;
      position: relative;
      &::before {
        content: "";
        width: calc(100% - 1rem);
        height: 0.5rem;
        background: #f1f2f5;
        position: absolute;
        z-index: 0;
        border-radius: 1rem;
        top: 0.3rem;
        left: 0.5rem;
      }
      .timeline-item {
        text-align: center;
        z-index: 1;
        &.orange {
          color: #ff9057;
          .circle {
            background: #ff9057;
          }
        }
        &.grey {
          color: #f1f2f5;
          .circle {
            background: #f1f2f5;
          }
        }
        &.blue {
          color: #3acce1;
          .circle {
            background: #3acce1;
          }
        }
        .circle {
          width: 1.13rem;
          height: 1.13rem;
          box-shadow: 0rem 0.19rem 0.38rem rgba(0, 0, 0, 0.16);
          opacity: 1;
          border-radius: 50%;
          margin: 0 auto;
          /* margin-top: -0.4rem; */
          &.success {
            position: relative;
            &::before,
            &::after {
              content: "";
              position: absolute;
              background: #fff;
            }
            &::before {
              width: 0.3rem;
              height: 0.1rem;
              transform: rotate(45deg);
              border-radius: 0.2rem;
              left: 0.3rem;
              top: 0.64rem;
            }
            &::after {
              width: 0.6rem;
              height: 0.1rem;
              transform: rotate(-45deg);
              border-radius: 0.2rem;
              left: 0.4rem;
              top: 0.55rem;
            }
          }
          &.late {
            .late-cir {
              position: relative;
              width: 0.8rem;
              height: 0.8rem;
              border-radius: 50%;
              border: 0.06rem solid #fff;
              margin: 0 auto;
              transform: translateY(0.14rem);
              &::before,
              &::after {
                content: "";
                position: absolute;
                background: #fff;
              }
              &::before {
                width: 0.05rem;
                height: 0.3rem;
                border-radius: 0.2rem;
                left: 0.3rem;
                top: 0.1rem;
              }
              &::after {
                width: 0.05rem;
                height: 0.25rem;
                border-radius: 0.2rem;
                transform: rotate(-45deg);
                top: 0.32rem;
                left: 0.37rem;
              }
            }
          }
        }
        .time {
          font-size: 0.6rem;
          margin-top: 0.3rem;
        }
      }
    }
  }
}
.screen {
  box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.08);
  background: #fff;
  border-radius: 0.85rem;

  .screen-wrap {
    padding: 0.8rem 1rem;
    color: #999;
    font-size: 0.85rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 0.75rem;
    }
  }
}
.list {
  overflow: hidden;
  margin-top: 1rem;
  border-radius: 1rem;
}
.info {
  display: flex;
  background: #fff;
  // box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.08);
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  padding: 0.5rem 0 1rem 0;
  justify-content: center;
  .info-item {
    flex: 1;
    text-align: center;
    border-right: 0.06rem solid #f4f4f6;
    &:last-child {
      border-right: none;
    }
    .info-count {
      font-size: 1.25rem;

      color: #454f63;
      .redinfo {
        color: rgb(255, 126, 151);
      }
      .unit {
        font-size: 0.69rem;
        color: #78849e;
        margin-left: 0.4rem;
      }
    }
    .info-name {
      color: #78849e;
      font-size: 0.69rem;
      margin-top: 0.3rem;
    }
  }
}
.screen-wrap-popup {
  padding: 20px;
  .screenwrap {
    padding: 0.5rem 1rem;
    .left {
      /* display; */
      /* padding: 0.7rem 0; */
      font-size: 0.8rem;
      vertical-align: middle;
      height: 2.3rem;
      line-height: 2.3rem;
    }
    .input-content {
      background: #f4f4f6;
      padding: 0rem 1rem;
      border-radius: 2rem;
      height: 2.3rem;
      line-height: 2.3rem;
    }
  }
  .screen-title {
    text-align: center;
    color: #999;
    font-size: 1rem;
  }
}

.class-date {
  padding: 15px 0 0px 0;
  span {
    margin: 0 20px;
    font-size: 15px;
    color: #1a1a1a;
  }
}
.cells {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  flex-wrap: wrap;
  background: transparent;
  position: relative;
  .lowerTop {
    position: absolute;
    font-size: 0.9rem;
    text-align: center;
    margin: 0 auto;
    line-height: 4vw;
    width: 4.5vw;
    height: 4.5vw;
  }
  .For {
    z-index: 1;
    .content {
      .yellow {
        color: rgb(241, 203, 42);
      }
      .red {
        color: rgb(255, 116, 144);
      }
      .none {
        color: rgb(26, 26, 26);
      }
      div {
        text-align: center;
        font-size: 0.9rem;
        width: 4.5vw;
        height: 4.5vw;
        .todayShow {
          background: rgb(121, 209, 255);
          border-radius: 50%;
          color: rgb(237, 249, 255);
          margin: 0 auto;
          line-height: 5vw;
          width: 5vw;
          height: 5vw;
          position: relative;
          top: -0.5vw;
          font-size: 0.8rem;
        }
        .show {
          line-height: 4vw;
          margin: 0 auto;
          width: 4.5vw;
          height: 4.5vw;
        }
        span {
          font-size: 0.5rem;
          position: absolute;
          right: -10%;
          top: 6%;
        }
        .state0 {
          display: none;
        }
        .state1 {
          color: rgb(58, 204, 225);
        }
        .state2 {
          color: rgb(240, 30, 30);
        }
      }
      .InOutTime {
        .timeRed {
          font-size: 0.8rem;
          color: rgb(255, 133, 157);
        }
        .timeYellow {
          font-size: 0.8rem;
          color: rgb(241, 204, 52);
        }
        .timeNone {
          p {
            text-align: center;
            font-size: 0.5rem;
          }
          .notShow {
            display: none;
          }
          .show {
            display: block;
            width: 100%;
            height: 0.5rem;
          }
          .late {
            color: rgb(255, 168, 124);
          }
        }
      }
    }
  }
}
.state0 {
  display: none;
}
.state1 {
  color: rgb(58, 204, 225);
  font-size: 0.5rem;
  position: absolute;
  right: -5%;
}
.state2 {
  color: rgb(240, 30, 30);
  font-size: 0.5rem;
  position: absolute;
  right: -5%;
}
::deep .el-calendar-table td.is-today{
  color: rgb(26, 26, 26);
}
</style>
